<div class="onboarding-container">
  <!-- Step Indicator -->
  <div class="step-indicator">
    <div class="step-circle">Step 1</div>
  </div>

  <!-- Profile Image -->
  <div class="profile-image-section">
    <div>
      <img src="assets/images/onboarding-profile.png" alt="Create account" class="profile-image">
    </div>
  </div>

  <!-- Description Text -->
  <div class="description-text">
    <h2>Create a new account or login</h2>
  </div>

  <!-- Next Button -->
  <div class="action-section">
    <button class="next-btn" (click)="onNext()">
      Next
    </button>
  </div>

  <!-- Pagination Dots -->
  <div class="pagination-dots">
    <div class="dot"></div>
    <div class="dot active"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
